// add user-agent to html element as data attribute
// (function() {
// 	var doc = document.documentElement;
// 	doc.setAttribute('data-useragent', navigator.userAgent);
// }());

// lazysizes before document ready
(function () {
	window.lazySizesConfig = window.lazySizesConfig || {};
	window.lazySizesConfig.customMedia = {
		"--small": "(max-width: 767px)",
		"--medium": "(max-width: 1023px)",
	};
})();

jQuery(document).ready(function ($) {
	// ---------------------------------------------------------------------
	// | sitewide                                                          |
	// ---------------------------------------------------------------------

	// img lazy load

	(function () {
		var startIOlazybgTimeout = 0;
		window.lazyIsLoaded = false;
		window.startIOlazybg = function () {
			clearTimeout(startIOlazybgTimeout);
			startIOlazybgTimeout = setTimeout(function () {
				if ("IntersectionObserver" in window) {
					var lazySelectors = [".lazy-img", ".lazy-bg"];
					lazySelectors.forEach(function (s, i) {
						var t = [].slice.call(document.querySelectorAll(s));
						var e = new IntersectionObserver(function (t, n) {
							t.forEach(function (t) {
								if (t.isIntersecting) {
									var n = jQuery(t.target);
									if (i === 0) {
										loadLazyIMGtag(n);
									}
									if (i === 1) {
										loadLazyBGimage(n);
									}
									e.unobserve(t.target);
								}
							});
						});
						t.forEach(function (t) {
							e.observe(t);
						});
					});
				} else {
					loadAllLazyItems();
				}
			}, 100);
		};
		window.loadAllLazyItems = function () {
			loadLazyIMGtags();
			loadLazyBGimages();
			lazyIsLoaded = true;
		};
		window.loadLazyIMGtags = function () {
			$("img.lazy-img").removeAttr("loading");
			$("img.lazy-img").each(function () {
				var $tg = $(this);
				loadLazyIMGtag($tg);
			});
		};
		window.loadLazyIMGtag = function ($tg) {
			var dataUrl = $tg.data("src");
			if (typeof dataUrl !== "undefined" && dataUrl !== "") {
				$("img.lazy-img").removeAttr("loading");
				$tg.attr("src", dataUrl);
			}
		};
		window.loadLazyBGimages = function () {
			$(".lazy-bg").each(function () {
				var $tg = $(this);
				loadLazyBGimage($tg);
			});
		};
		window.loadLazyBGimage = function ($tg) {
			var dataUrl = $tg.data("bgurl");
			if (typeof dataUrl !== "undefined" && dataUrl !== "") {
				$tg.css("backgroundImage", "url(" + dataUrl + ")");
			}
		};

		window.startIOlazybg();
	})();

	// nav
	(function () {
		// mobile nav class
		enquire.register("screen and (max-width: 1023px)", {
			setup: function () {
				$(".jsToggleMobileNav").on("click", function () {
					$("html").toggleClass("nav-open");
				});
			},
			unmatch: function () {
				// hide mobile nav when leaving mobile breakpoint
				if ($("html").hasClass("nav-open")) {
					$(".jsToggleMobileNav").click();
				}
			},
		});
		// desktop overlay
		enquire.register("screen and (min-width: 1024px)", {
			setup: function () {
				$("#main-nav .dropdown a").on("click", function () {
					$("html").toggleClass("overlay");
				});
				$(".nav-overlay").on("click", function () {
					$("html").removeClass("overlay");
				});
				$(
					".page-utility-nav, .page-utility-nav .col, .page-utility-nav ul, #page-nav, #main-nav"
				).on("click", function (e) {
					if ($(".overlay").length) {
						if ($(e.target).is(this)) {
							$("html").removeClass("overlay");
						}
					}
				});
			},
		});
	})();

	// main min height
	(function calcHeight() {
		var $calcHeight;
		getHeight();
		$(window).on("resize", function () {
			$calcHeight = true;
		});
		setInterval(function () {
			if ($calcHeight) {
				getHeight();
				$calcHeight = false;
			}
		}, 300);
		function getHeight() {
			var $pageHeight = window.innerHeight;
			var $mainHeight = $("#page-main").outerHeight();
			var $footerHeight = $("#page-footer").outerHeight();
			var $setHeight = Math.ceil($pageHeight - $footerHeight);
			if ($mainHeight < $pageHeight) {
				$(document).find("#page-main").css("min-height", $setHeight);
			}
		}
	})();

	// svg images
	(function () {
		$(".jsSVG").each(function () {
			var $img = $(this);
			var imgID = $img.attr("id");
			var imgClass = $img.attr("class");
			var imgURL = $img.attr("src");
			$.get(
				imgURL,
				function (data) {
					// Get the SVG tag, ignore the rest
					var $svg = $(data).find("svg");
					// Add replaced image's ID to the new SVG
					if (typeof imgID !== "undefined") {
						$svg = $svg.attr("id", imgID);
					}
					// Add replaced image's classes to the new SVG
					if (typeof imgClass !== "undefined") {
						$svg = $svg.attr("class", imgClass + " replaced-svg");
					}
					// Remove any invalid XML tags as per http://validator.w3.org
					$svg = $svg.removeAttr("xmlns:a");
					// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
					if (
						!$svg.attr("viewBox") &&
						$svg.attr("height") &&
						$svg.attr("width")
					) {
						$svg.attr(
							"viewBox",
							"0 0 " +
								$svg.attr("height") +
								" " +
								$svg.attr("width")
						);
					}
					// Replace image with new SVG
					$img.replaceWith($svg);
				},
				"xml"
			);
		});
	})();

	// ---------------------------------------------------------------------
	// | components                                                        |
	// ---------------------------------------------------------------------

	// carousel
	(function () {
		// init carousel
		var $carousel = $(".js-carousel").flickity({
			autoPlay: 5000,
			wrapAround: true,
			cellSelector: ".carousel-cell",
		});
		var flkty = $carousel.data("flickity");
		// when only one slide - add class to hide dots/arrows and disable dragging
		if ($carousel.length) {
			if (flkty.cells.length < 2) {
				flkty.unbindDrag();
				$carousel.addClass("single-slide");
			}
		}
		// https://github.com/metafizzy/flickity/issues/71
		function onLoadeddata(event) {
			var cell = $carousel.flickity("getParentCell", event.target);
			$carousel.flickity("cellSizeChange", cell && cell.element);
		}
		$carousel.find(".js-video-player").each(function (i, video) {
			video.play();
			$(video).on("loadeddata", onLoadeddata);
		});
	})();

	// Store Detail carousel
	(function () {
		// init carousel
		// $autoplay = $('.store-carousel').attr("data-autoplay");
		var $carousel = $(".store-carousel").flickity({
			autoPlay: 5000,
			adaptiveHeight: true,
			prevNextButtons: false,
			wrapAround: true,
			cellSelector: ".carousel-cell",
		});
		var flkty = $carousel.data("flickity");
		// when only one slide - add class to hide dots/arrows and disable dragging
		if ($carousel.length) {
			if (flkty.cells.length < 2) {
				flkty.unbindDrag();
				$carousel.addClass("single-slide");
			}
		}
		// https://github.com/metafizzy/flickity/issues/71
		function onLoadeddata(event) {
			var cell = $carousel.flickity("getParentCell", event.target);
			$carousel.flickity("cellSizeChange", cell && cell.element);
		}

		$(".store-carousel")
			.find(".carousel-cell")
			.hover(
				function () {
					$(this).addClass("hovered");
				},
				function () {
					$(this).removeClass("hovered");
				}
			);
	})();

	// checkboxes & radios
	(function () {
		if ($("form .checkbox").length || $(".radio").length) {
			// checkbox
			$("form .checkbox").iCheck({
				checkboxClass: "icheckbox_square-blue",
			});
			// radio
			$(".radio").iCheck({
				radioClass: "iradio_square-blue",
			});
			// label styling
			$("form .checkbox input, .radio input").on(
				"ifToggled",
				function (event) {
					$(this).closest("label").toggleClass("checked");
				}
			);
			// prevent label click from propagating to child links
			$("label a").on("click", function (e) {
				e.stopPropagation();
				e.preventDefault();
				window.open($(this).attr("href"), $(this).attr("target"));
				return false;
			});
			// prevent child link hover from activiating parent label hover
			$("label a").on("mouseenter focus", function (e) {
				var $icheck = $(this)
					.parents("label")
					.find(".icheckbox_square-blue");

				if (!$icheck.hasClass("checked")) {
					$icheck.css({
						"border-color": "#e5e5e5",
						"box-shadow": "inset 0 3px 3px #e5e5e5",
					});
				} else {
					$icheck.css({
						"border-color": "#222",
						"box-shadow": "none",
					});
				}
			});
			$("label a").on("mouseout blur", function (e) {
				$(this)
					.parents("label")
					.find(".icheckbox_square-blue")
					.removeAttr("style");
			});
		}
	})();

	// scroll to
	(function () {
		$(".scroll-to").on("click", function (e) {
			var target = $($(this).attr("href"));
			target = target.length
				? target
				: $("[name=" + this.hash.slice(1) + "]");
			var header = $("#page-header").outerHeight();
			if (target.length) {
				e.preventDefault();
				$("html, body").animate(
					{
						scrollTop: target.offset().top - header,
					},
					400
				);
			}
		});
	})();

	// sub-nav sidebar menus
	(function () {
		// nav behaviour
		// if ($('.side-nav').length) {
		// 	$('.side-nav a.dropdown-toggle').on('click', function(e) {
		// 		e.stopPropagation();
		// 	});
		// 	if ($('.side-nav li').hasClass('active')) {
		// 		$('.side-nav .active').addClass('open').parentsUntil('.side-nav').not('ul').addClass('open');
		// 		$('.side-nav .open').on('hide.bs.dropdown', function() {
		// 			return false;
		// 		});
		// 	}
		// }
		// mobile specific
		enquire.register("screen and (max-width: 767px)", {
			setup: function () {
				if ($(".side-nav li").hasClass("active")) {
					var breadcrumb = $(".side-nav .active a").html();
					$(".side-nav .crumbs").html(
						"<span>" + breadcrumb + "</span>"
					);
				}
				$(".side-nav .js-toggle-side-nav").on("click", function (e) {
					e.preventDefault();
					$(this)
						.parents(".side-nav")
						.find("li")
						.toggleClass("js-show");
				});
			},
		});
	})();

	// wysiwyg
	(function () {
		// iframe
		$(".ww > iframe").each(function () {
			var $this = $(this);
			var src = $this.attr("src");
			var video_data = parseVideoURL(src);
			$(this).removeAttr("style width height");
			if(video_data && video_data.provider == 'youtube'){
				$(this).wrap('<div class="iframe-responsive iframe-responsive--youtube"></div>');
			}else{
				$(this).wrap('<div class="iframe-responsive"></div>');

				$(this)
				.parent(".iframe-responsive")
				.on("click", function () {
					$this.css("pointer-events", "auto");
				});
			}
		});
		// tables
		$(".ww > table").each(function () {
			$(this).wrap('<div class="table-responsive"></div>');
		});

		function parseVideoURL(url) {
			var retVal = {};
			var matches;
			var regYt =
				/^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
			var matchYt = url.match(regYt);
			if (matchYt && matchYt[2].length >= 10) {
				retVal.provider = "youtube";
				retVal.id = matchYt[2];
			} else if ((matches = url.match(/vimeo.com\/(\d+)/))) {
				retVal.provider = "vimeo";
				retVal.id = matches[1];
			}
			return retVal;
		}
	})();

	// ---------------------------------------------------------------------
	// | pages                                                             |
	// ---------------------------------------------------------------------

	if ($(".page-home").length) {
		// homepage mobile accordions
		(function () {
			$(".js-home-connect-toggler").on("click", function (e) {
				$(this).parent().parent().toggleClass("open");
				$(this)
					.parent()
					.siblings(".js-home-connect-mobile-hidden")
					.slideToggle(200);
			});
		})();

		// subscribe modal
		(function () {
			var $collectorForm = $(".js-subscribe-form-collector");
			var $collectorEmailField = $collectorForm.find(".js-email");
			var $collectorEmailFormGroup =
				$collectorEmailField.parents(".form-group");
			var $collectorBtn = $collectorForm.find(".js-btn");
			var $modalEmailField = $(".js-subscribe-form-in-modal").find(
				".js-email input"
			);

			var validateEmail = function (email) {
				var re =
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			};

			$collectorBtn.on("click", function (e) {
				e.preventDefault();
				var email = $collectorEmailField.val();
				if (validateEmail(email)) {
					$modalEmailField.val(email);
					$collectorEmailFormGroup.removeClass("has-error");
					$("#subscribe-modal").modal("show");
				} else {
					$collectorEmailFormGroup.addClass("has-error");
				}
			});
		})();

		//mirror subscribe modal email value
		$('.subscribe-form input[type="email"]').bind(
			"keypress keyup blur",
			function () {
				$(
					'.subscribe-form.js-subscribe-form-in-modal form input[type="email"]'
				).val($(this).val());
			}
		);
	}

	// ---------------------------------------------------------------------
	// | experience editor                                                 |
	// ---------------------------------------------------------------------

	if ($(".page-editor").length) {
		$("#page-header").each(function () {
			$(this)
				.nextUntil(document.body)
				.addBack()
				.wrapAll('<div class="experience-editor">');
		});
	}

	// ---------------------------------------------------------------------
	// | form wrapp                                                  |
	// ---------------------------------------------------------------------
	if ($(".form.standard-form").length) {
		$("label").each(function () {
			var label = $(this);
			var vLc = $(this).find("input[type='checkbox']");
			var dataSCFieldKey = vLc.attr("data-sc-field-key");
			if (dataSCFieldKey != undefined) {
				if (vLc.length > 0) {
					$(this).addClass("container-checkbox");
					$(this).append("<span class='checkmark'></span>");
				}
				if (label.parents(".modal").length) {
					// console.log("form on modal");
				} else {
					if (vLc.hasClass("content-rawhtml")) {
						$(this)
							.next(".field-validation-valid")
							.addClass("field-validation-rawhtml");
						$(this).addClass("container-checkbox-rawhtml");
					}

					$(vLc).on("change", function () {
						if (vLc.attr("data-val-ischecked") != undefined) {
							if ($(this).prop("checked")) {
								label
									.next(".field-validation-error")
									.removeClass("field-validation-error")
									.addClass("field-validation-valid")
									.empty();
							} else {
								label
									.next(".field-validation-valid")
									.removeClass("field-validation-valid")
									.addClass("field-validation-error")
									.text(vLc.attr("data-val-ischecked"));
							}
						}
					});
				}
			}
		});
		$(".form.standard-form").each(function () {
			if ($(this).find(".submit-wrapper").length) {
				return;
			}

			submitButton = $(this).find("input[type='submit']");
			submitButton.wrapAll("<div class='submit-wrapper'></div>");
			$("label[for]").empty();
		});

		$("label").each(function () {
			var vLcC = $(this).find(".checkmark");
			vLcC.click(function () {
				if (vLcC.length > 0) {
					vLcC.parents("label").toggleClass("checked");
				}
			});
		});
	}

	if ($(".breadcrumbs").length) {
		if ($(".form.standard-form").length) {
			$(".form.standard-form").each(function () {
				parentRawHtml = $(this).find(".view-rawhtml");
				parentRawHtmlClone = $(this).find(".view-rawhtml.clone-data");

				// Only for privacy
				$("label").each(function () {
					var contentRaw = $(this).find(".content-rawhtml");
					var cloneDataRaw = $(this).find(".view-rawhtml");

					if (contentRaw.length > 0) {
						if (cloneDataRaw.length > 0) {
						} else {
							contentRaw
								.parents("label")
								.addClass("privacy-checked");
							parentRawHtml
								.clone()
								.insertAfter(".content-rawhtml");
							var viwContentRaw = $(this).find(".view-rawhtml");
							viwContentRaw.addClass("clone-data");
						}
					}
				});
				parentRawHtml.hide();
				parentRawHtmlClone.show();
			});
		}
	} else {
		//onload home
		if ($(".form.standard-form.subscribe-modal").length) {
			$(".form.standard-form.subscribe-modal").each(function () {
				parentRawHtml = $(this).find(".view-rawhtml");
				parentRawHtmlClone = $(this).find(".view-rawhtml.clone-data");

				// Only for privacy
				$(this)
					.find("label")
					.each(function () {
						var contentRaw = $(this).find(".content-rawhtml");
						var cloneDataRaw = $(this).find(".view-rawhtml");

						if (contentRaw.length > 0) {
							if (cloneDataRaw.length > 0) {
							} else {
								contentRaw
									.parents("label")
									.addClass("privacy-checked");
								parentRawHtml
									.clone()
									.insertAfter(".content-rawhtml");
								var viwContentRaw =
									$(this).find(".view-rawhtml");
								viwContentRaw.addClass("clone-data");
							}
						}
					});
				// parentRawHtml.hide();
				// parentRawHtmlClone.show();
			});

			$(".form.standard-form.subscribe-modal").each(function () {
				var all_htmltext = $(this).find(".view-rawhtml");
				var inside_htmltext = $(this).find("label .view-rawhtml");

				all_htmltext.css("display", "none");
				inside_htmltext.removeAttr("style");
			});
		}
	}

	// ---------------------------------------------------------------------
	// | utility                                                  |
	// ---------------------------------------------------------------------
	// match div height
	(function matchHeight() {
		if ($(window).width() >= 768) {
			autoHeight();
		} else {
			$(".row").each(function () {
				$(".same-height", this).each(function () {
					$(this).css("height", "auto");
				});
			});
		}

		$(window).on("resize", function () {
			if ($(window).width() >= 768) {
				autoHeight();
			} else {
				$(".row").each(function () {
					$(".same-height", this).each(function () {
						$(this).css("height", "auto");
					});
				});
				return;
			}
		});

		function autoHeight() {
			$(".row").each(function () {
				// Cache the highest
				var highestBox = 0;

				// Select and loop the elements you want to equalise
				$(".same-height", this).each(function () {
					// If this box is higher than the cached highest then store it
					if ($(this).height() > highestBox) {
						highestBox = $(this).height();
					}
				});

				// Set the height of all those children to whichever was highest
				$(".same-height", this).height(highestBox);
			});
		}
	})();

	// // ---------------------------------------------------------------------
	// // | masonry carousel                                                  |
	// // ---------------------------------------------------------------------
	(function masonry() {
		var wrap = $(".masonry-carousel");
		if (!wrap.length) {
			return;
		}

		$(".masonry-carousel").slick({
			centerMode: true,
			variableWidth: true,
			centerPadding: "0px",
			slidesToShow: 3,
			autoplay: true,
			autoplaySpeed: 4000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerMode: true,
						centerPadding: "40px",
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 480,
					settings: {
						centerMode: true,
						centerPadding: "40px",
						slidesToShow: 1,
					},
				},
			],
		});
	})();
});
